import { all, takeLatest, call, select } from 'redux-saga/effects';

import * as actions from '@blueberry/redux/navigation';
import { getLocaleCode } from '@blueberry/redux/locale';

import { DASHBOARD_STUDENT_SCORE_RECORD } from '@blueberry/constants/dashboardRouting';
import config from '@blueberry/config';

const { SNAPASK_SITE_ENDPOINT, WIZMO_SITE_ENDPOINT } = config;

const getLandingURL = targetPage => `${SNAPASK_SITE_ENDPOINT}/${targetPage}`;

export function* home(history) {
  const localeCode = yield select(getLocaleCode);
  yield call(history.push, `/${localeCode}`);
}

export function* openExternalUrl(action) {
  const {
    payload: { url, newTab },
  } = action;
  window.open(url, newTab ? '_blank' : '_self');
}

export function* landingPageFlow(action) {
  const {
    payload: { path },
  } = action;
  const url = getLandingURL(path);
  window.location = url;
}

export function* campaignResultFlow(history, action) {
  const localeCode = yield select(getLocaleCode);
  const {
    payload: { name },
  } = action;

  const url = `/${localeCode}/campaign/${name}/result`;
  // if user logedin should redirect parent page
  if (window.top) {
    window.top.location = `${window.location.origin}${url}`;

    return;
  }

  yield call(history.push, url);
}

export function* landingPageWithReturnFlow(action) {
  const {
    payload: { path, returnUrl },
  } = action;
  const url = `${getLandingURL(path)}?returnto=${returnUrl}`;
  // in case not really in iframe
  if (returnUrl && !!window.top) {
    window.top.location = url;

    return;
  }

  window.location = url;
}

export function* campaignPageFLow(history, action) {
  const localeCode = yield select(getLocaleCode);
  const {
    payload: { name },
  } = action;

  const url = `/${localeCode}/campaign/${name}`;

  yield call(history.push, url);
}

export function* dashboardScoreRecordFlow(history) {
  const url = '/dashboard/scorerecord';

  yield call(history.push, url);
}

export function* dashboardStudentDetailFlow(history, action) {
  const {
    payload: { studentId, semesterId, subjectId, classId, recordId },
  } = action;

  const url = DASHBOARD_STUDENT_SCORE_RECORD.replace(':studentId', studentId)
    .replace(':semesterId', semesterId)
    .replace(':classId', classId)
    .replace(':subjectId', subjectId)
    .replace(':recordId', recordId);

  yield call(history.push, url);
}

export function* wizmoPageFlow(action) {
  const { path } = action.payload;
  const localeCode = yield select(getLocaleCode);

  window.location = `${WIZMO_SITE_ENDPOINT}/${localeCode}/${path}`;
}

export function* academyPageFlow(history, action) {
  const { name } = action.payload;
  const localeCode = yield select(getLocaleCode);
  yield call(history.push, `/${localeCode}/page/${name}`);
}

export default function*(context) {
  const { history } = context;

  yield all([
    takeLatest(actions.HOME, home, history),
    takeLatest(actions.LANDING_PAGE, landingPageFlow),
    takeLatest(actions.CAMPAIGN_RESULT, campaignResultFlow, history),
    takeLatest(actions.EXTERNAL_URL, openExternalUrl),
    takeLatest(actions.LANDING_PAGE_WITH_RETURN, landingPageWithReturnFlow),
    takeLatest(actions.CAMPAIGN_PAGE, campaignPageFLow, history),
    takeLatest(
      actions.STUDENT_DETAIL_PAGE,
      dashboardStudentDetailFlow,
      history
    ),
    takeLatest(
      actions.DASHBOARD_SCORERECORD_LIST,
      dashboardScoreRecordFlow,
      history
    ),
    takeLatest(actions.WIZMO_PAGE, wizmoPageFlow),
    takeLatest(actions.ACADEMY_PAGE, academyPageFlow, history),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/navigation.js